import { USER_TYPES, isValidUserType, type UserType } from "../../permissions";
import type { TProfileAccess } from "../../store/user";

type CurrentUserResponse = {
  name?: string;
  userType?: string;
  businessProfiles?: string[];
  profileAccesses?: TProfileAccess[];
  data?: {
    name?: string;
    userType?: string;
    businessProfiles?: string[];
    profileAccesses?: TProfileAccess[];
  };
};

export const normalizeCurrentUserResponse = (response: CurrentUserResponse) =>
  response.data ?? response;

export const normalizeOAuthUserType = (userType?: string): UserType =>
  userType && isValidUserType(userType) ? userType : USER_TYPES.CUSTOMER;

export const getOAuthRedirectPath = ({
  userType,
  businessProfiles,
}: {
  userType?: string;
  businessProfiles?: string[];
}) => {
  if (userType === "CUSTOMER") {
    return "/home";
  }

  return (businessProfiles?.length ?? 0) > 0 ? "/select-profile" : "/georanking";
};
